// outbound 도메인 공통 비즈니스 상수.
// 특정 페이지(outboundSchedule2, outboundWaitingStatus 등)에 한정되지 않고 여러 페이지/서비스가 공유하는 값만 둔다.

// 출고대기시간 입력 가능 범위 (분 단위, 10분 step)
// - outboundSchedule2 SetWaitTimeModal: 사용자 입력 validation
// - outboundWaitingStatus 출고지시 대기 수량 패널: MAX_WAIT_TIME 윈도우 안 슬롯만 노출
export const MIN_WAIT_TIME = 10
export const MAX_WAIT_TIME = 540
export const WAIT_TIME_STEP = 10

// 저장 진행률(GET /api/v1/outbound-progress/{key})이 멈추는 상태 — 공용 진행률 모달(components/OutboundProgressModal)이 [확인]·ESC 를 이 상태에서만 푼다.
export const OUTBOUND_PROGRESS_DONE_STATUSES = ['COMPLETED', 'FAILED']
